import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogOverlay,
} from '@/components/ui/dialog';

interface ModalProps {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  title?: string;
  children: React.ReactNode;
  description?: string;
  style?: string | boolean;
  closeBtn?: React.ReactNode;
  bgBlur?: boolean;
  fullWidth?: boolean;
  modal?: boolean;
}

export function Modal({
  open,
  onOpenChange,
  title,
  description,
  children,
  style,
  closeBtn,
  bgBlur = false,
  fullWidth = false,
  modal = true,
}: ModalProps) {
  const customClassName = typeof style === 'string' ? style : '';

  return (
    <Dialog open={open} onOpenChange={onOpenChange} modal={modal}>
      {bgBlur && <DialogOverlay className="bg-transparent backdrop-blur-[5px]" />}
      <DialogContent
        className={`fixed left-1/2 top-1/2 z-50 w-[calc(100vw-1rem)] ${
          fullWidth ? 'md:w-[95vw]' : 'md:w-[760px] md:min-w-[640px]'
        } max-w-[calc(100vw-1rem)] md:max-w-5xl md:min-h-[240px] -translate-x-1/2 -translate-y-1/2 overflow-auto max-h-[95vh] p-3 md:p-4 ${customClassName} [&>button.absolute]:hidden bg-modalBg text-black`}
      >
        {/* HEADER → title left + close button right */}
        {(title || closeBtn) && (
          <DialogHeader className="flex flex-row items-start justify-between gap-4 border-b border-green3 pb-2 text-textcolor">
            <div className="min-w-0 flex-1">
              <DialogTitle className="break-words pr-2 text-xl font-semibold">{title}</DialogTitle>
              {description && (
                <DialogDescription className="text-gray-500">{description}</DialogDescription>
              )}
            </div>

            {/* custom close button */}
            {closeBtn && (
              <div onClick={() => onOpenChange?.(false)} className="shrink-0 cursor-pointer">
                {closeBtn}
              </div>
            )}
          </DialogHeader>
        )}

        {children}
      </DialogContent>
    </Dialog>
  );
}
